import React from "react";
import S1 from "./components/S1";
import S2 from "./components/S2";
import S3 from "./components/S3";
import S4 from "./components/S4";
import S5 from "./components/S5";
import S6 from "./components/S6";

const Home = () => {
  return (
    <div className="gogocredi-home-container">
      <S1 />
      <S2 />
      <S3 />
      <S4 />
      <S5 />
      <S6 />
    </div>
  )
}

export default Home;
